import type { DeckConfigEntry } from 'src/components/star-grid/deckConfig.types';
import type { PnlPivotColumn, PnlScenarioEntry } from 'src/components/star-grid/starGridTypes';
import { PNL_ACTUALS_SCENARIO_ID } from 'src/components/star-grid/starGridConstants';
import { isScenarioEntry } from 'src/components/star-grid/utils/deckEntryFields';
/** LE is a per-period deck setting; never infer a historical open month from today's date. */
export const deckPeriodType = (
  group: string,
  period: string,
  scenarios: readonly PnlScenarioEntry[],
  entries: readonly DeckConfigEntry[]
): PnlPivotColumn['periodType'] => {
  const columns = entries.filter((entry) => isScenarioEntry(entry) && (entry.column_name || entry.fpa_deck_scenario) === group);
  const entry = columns.find((item) => (item.time_period || String(item.month_id)) === period);
  if (!entry) return undefined;
  const scenario = scenarios.find((item) => item.label === group);
  const actuals = scenario
    ? scenario.reporting_scenario_id === PNL_ACTUALS_SCENARIO_ID
    : columns.some((item) => item.reporting_scenario_id === PNL_ACTUALS_SCENARIO_ID);
  if (!actuals) return undefined;
  return /^\d{6}$/.test(period) && entry.le_adjustment === true ? 'forecast' : 'actual';
};
